<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="28" fill="#464646" fill-opacity="0.5"/>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.7621 21.5129C27.0903 21.1848 27.5353 21.0005 27.9993 21.0005C28.4634 21.0005 28.9084 21.1848 29.2366 21.5129L39.1363 31.4126C39.4551 31.7427 39.6315 
        32.1847 39.6275 32.6436C39.6235 33.1024 39.4395 33.5413 39.115 33.8658C38.7906 34.1903 38.3516 34.3743 37.8928 34.3783C37.4339 34.3823 36.9919 34.2059 36.6618 
        33.8871L27.9993 25.2246L19.3368 33.8871C19.0068 34.2059 18.5647 34.3823 18.1059 34.3783C17.647 34.3743 17.2081 34.1903 16.8837 33.8658C16.5592 33.5413 16.3751 
        33.1024 16.3712 32.6436C16.3672 32.1847 16.5436 31.7427 16.8623 31.4126L26.7621 21.5129Z"
      fill="white"
    />
  </svg>
</template>

